import CoverCards from "./CoverCards";
import CoverHeadline from "./CoverHeadline";

export default function CoverSection() {
  return (
    <>
      <CoverHeadline />
      <CoverCards />
    </>
  );
}
